import { useState } from 'react';
import PayrollDaySequencesSection from '@/modules/payroll/components/daySequences/PayrollDaySequencesSection';
import PayrollPayRunsSection from '@/modules/payroll/components/payRuns/PayrollPayRunsSection';
import {
  getPayrollSections,
  type PayrollSectionKey,
  type PayrollView,
} from '@/modules/payroll/views/payroll.view';

type PayrollTabProps = {
  view: PayrollView;
};

/** Day Sequences and Pay Runs & Cycle Logs, as sections the view allows. */
const PayrollTab = ({ view }: PayrollTabProps) => {
  const sections = getPayrollSections(view.payrollSections);
  const [selectedSection, setSelectedSection] = useState<
    PayrollSectionKey | undefined
  >(view.payrollSections[0]);

  if (!selectedSection) {
    return (
      <div className="rounded-lg border bg-white p-6 text-sm text-gray-600">
        You don&apos;t have access to any payroll sections.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 rounded-lg border bg-white p-6">
      <div className="inline-flex self-start rounded-md border border-gray-200 p-1">
        {sections.map((section) => (
          <button
            key={section.key}
            type="button"
            onClick={() => setSelectedSection(section.key)}
            className={`rounded px-4 py-1.5 text-sm font-medium transition-colors ${
              selectedSection === section.key
                ? 'bg-[#03406A] text-white'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            {section.label}
          </button>
        ))}
      </div>
      {selectedSection === 'daySequences' && (
        <PayrollDaySequencesSection view={view} />
      )}
      {selectedSection === 'payRuns' && <PayrollPayRunsSection view={view} />}
    </div>
  );
};

export default PayrollTab;
